// Endereço de um anexo de chat.
//
// Os arquivos deixaram de ser servidos estaticamente em /storage, onde
// qualquer um com a URL baixava — sem sessão e sem empresa. Agora passam por
// `GET /messages/{roomId}/attachment?path=...`, que exige a sala, o caminho
// exato, e uma mensagem daquela sala que realmente o referencie.
//
// A barreira é a MESMA das mensagens: quem conhece a sala já lê todo o texto
// dela pelo mesmo grupo de rotas. O anexo não deve ser mais fácil nem mais
// difícil de obter que o texto ao qual pertence.
//
// Aqui não vai cabeçalho de tenant: o slug viaja nas chamadas do cliente
// HTTP, mas um `<img src>` não manda cabeçalho nenhum. Por isso o
// identificador da sala está no CAMINHO — é dele que o servidor resolve a
// empresa.

const API = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

/**
 * @param {string} roomId  identificador da sala
 * @param {string} archive caminho guardado na mensagem, ex.: images/x.png
 */
export const chatAttachmentUrl = (roomId, archive) => {
  if (!roomId || !archive) return '';

  // Já é dado embutido ou endereço externo: não há o que intermediar.
  if (/^(data:|blob:|https?:)/i.test(archive)) return archive;

  const caminho = String(archive).replace(/^\/+/, '');

  return `${API}/messages/${encodeURIComponent(roomId)}/attachment?path=${encodeURIComponent(caminho)}`;
};
